module.exports = __webpack_public_path__ + "media/customizations/tributary/logo-eeada2538b8e9ee94c9642c78d35c821.png";